var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex items-center justify-between w-full" },
    [
      _c(
        "div",
        { staticClass: "flex items-center" },
        [
          _c("TableAvatar", {
            staticClass: "multiselect_avatar mr-1",
            attrs: {
              avatarClasses: "w-6 h-6",
              image: _vm.avatar,
              initial: _vm.initials,
              title: _vm.option.name,
              primary: "",
              highlightAvatar: "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "image",
                  fn: function ({ image, defaultClasses }) {
                    return [
                      _vm._t("image", null, {
                        image: image,
                        defaultClasses: defaultClasses,
                      }),
                    ]
                  },
                },
                {
                  key: "initial",
                  fn: function ({ defaultClasses }) {
                    return [
                      _vm._t("initial", null, {
                        defaultClasses: defaultClasses,
                        initial: _vm.initials,
                      }),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
          _vm._t("default"),
        ],
        2
      ),
      _vm.isBookmarked
        ? _c(
            "div",
            { staticClass: "ml-2 flex-shrink-0" },
            [
              _c("BookmarkIcon", {
                attrs: { bookmarked: true, size: "w-4 h-4" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.isBookmarked
        ? _c(
            "div",
            { staticClass: "ml-1 text-xs bg-yellow-200 px-1 rounded" },
            [_vm._v(" BOOKMARKED ")]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }